/* *************** 视频SDK Demo start ******************* */
var RES_CAMERA_FINDPAGE_SDK = '/eits/video/monitor/find/page'; // 全局查询可播放的视频列表

var GET_RECORD_LIST_SDK = '/eits/video/by/time'; // 获取一段时间内的视频片段列表

var GET_SMALL_TOKEN_SDK = '/eits/video/restricted/token/get'; // 获取萤石小token

var PTZ_CONTROL_SDK = '/eits/video/device/ptz'; // 云台操作相关

var RES_CAMERA_DETAIL_SDK = '/eits/video/monitor/find/by/id'; // 获取单个视频信息

/* *************** 视频SDK Demo end ******************* */

/* *************** loginSDK Demo start ******************* */

var LOGIN_SDK = '/judgeagent/eits/login/v2'; // 登录

var VERIFY_CODE_SDK = '/judgeagent/eits/login/verifyCode'; // 滑动检测

var CHALLENGE_CODE_SDK = '/judgeagent/eits/login/challengeCode'; // 请求挑战码

var PHONE_VERIFY_CODE_SDK = '/judgeagent/eits/login/phone/verifyCode'; // 请求手机验证码

var CHECK_CODE_SDK = '/judgeagent/eits/login/phone/checkCode '; // 校验手机验证码

var CHANGE_PWD_SDK = '/judgeagent/eits/login/changePwd'; // 修改密码 (忘记密码去重置的时候)

var UPDATE_PWD_SDK = '/judgeagent/eits/login/user/pwd/update'; // 修改密码接口（需要token）用于首次登陆或者弱密码，或者右上角主动修改密码,用户列表右侧修改密码的情况

var PHONE_STATUS_SDK = '/judgeagent/eits/login/phone/status';
var LOGOUT_SDK = '/judgeagent/eits/logout';
var CLEAR_LOGIN_INFO_SDK = '/judgeagent/clearLoginInfo';
/* *************** login Demo end ******************* */

var GET_USER_INFO = '/judgeagent/eits/web/auths'; // 登录用户的基础信息和权限信息

export default {
  RES_CAMERA_FINDPAGE_SDK: RES_CAMERA_FINDPAGE_SDK,
  GET_RECORD_LIST_SDK: GET_RECORD_LIST_SDK,
  GET_SMALL_TOKEN_SDK: GET_SMALL_TOKEN_SDK,
  PTZ_CONTROL_SDK: PTZ_CONTROL_SDK,
  RES_CAMERA_DETAIL_SDK: RES_CAMERA_DETAIL_SDK,
  // login sdk
  LOGIN_SDK: LOGIN_SDK,
  LOGOUT_SDK: LOGOUT_SDK,
  VERIFY_CODE_SDK: VERIFY_CODE_SDK,
  CHALLENGE_CODE_SDK: CHALLENGE_CODE_SDK,
  PHONE_VERIFY_CODE_SDK: PHONE_VERIFY_CODE_SDK,
  CHECK_CODE_SDK: CHECK_CODE_SDK,
  CHANGE_PWD_SDK: CHANGE_PWD_SDK,
  UPDATE_PWD_SDK: UPDATE_PWD_SDK,
  PHONE_STATUS_SDK: PHONE_STATUS_SDK,
  GET_USER_INFO: GET_USER_INFO,
  CLEAR_LOGIN_INFO_SDK: CLEAR_LOGIN_INFO_SDK
};